import { render, staticRenderFns } from "./VendorOverviewPage.vue?vue&type=template&id=a886fe12&scoped=true&"
import script from "./VendorOverviewPage.vue?vue&type=script&lang=js&"
export * from "./VendorOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./VendorOverviewPage.vue?vue&type=style&index=0&id=a886fe12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a886fe12",
  null
  
)

export default component.exports